import 'reflect-metadata';
import { createRoot } from 'react-dom/client';
import { DependencyContainerUtil } from '@gen-epix/ui-client-common/utils/DependencyContainerUtil';
import { I18nService } from '@gen-epix/ui-client-common/classes/services/I18nService';
import { WindowService } from '@gen-epix/ui-core/classes/services/WindowService';
import { CaseDbApp } from '@gen-epix/ui-client-casedb/components/app/CaseDbApp';
import { setupCaseDb } from '@gen-epix/ui-client-casedb/setup/setup';
import { container } from 'tsyringe';

import { ConfigUtil } from './utils/ConfigUtil';
import { PiwikProUtil } from './utils/PiwikProUtil';

const LOCAL_STORAGE_KEY_PREFERRED_LANGUAGE = 'LSP-preferred-language';


const init = async () => {
  await container.resolve(I18nService).init({
    getCurrentLanguageCode: async () => {
      return Promise.resolve(container.resolve(WindowService).window.localStorage.getItem(LOCAL_STORAGE_KEY_PREFERRED_LANGUAGE) ?? window.navigator.language.split('-')[0] ?? 'en');
    },
    languageConfigs: [
      {
        bundles: [
          '/locale/en.json',
        ],
        code: 'en',
      },
      {
        bundles: [
          '/locale/nl.json',
        ],
        code: 'nl',
      },
    ],
    setNewLanguageCode: async (code: string) => {
      return Promise.resolve(container.resolve(WindowService).window.localStorage.setItem(LOCAL_STORAGE_KEY_PREFERRED_LANGUAGE, code));
    },
  });
  const config = ConfigUtil.createConfig();
  DependencyContainerUtil.registerConfig(config);
  setupCaseDb();
  PiwikProUtil.setup(container);

  createRoot(document.getElementById('root')).render(
    <CaseDbApp />,
  );
};

init().catch((error) => {
  console.error('Failed to initialize the application', error);
});
